jQuery(document).on(
	"gform_post_render",
	function (event, form_id, current_page) {
		// Get all input containers with the "material-input" class
		var containers = document.querySelectorAll(".material-input");

		// Attach event listeners for input focus, blur, and input events
		for (var i = 0; i < containers.length; i++) {
			var input = containers[i].querySelector("input, textarea"); // Include textarea element
			var label = containers[i].querySelector("label");

			if (input && label) {
				input.addEventListener("focus", handleInputFocus);
				input.addEventListener("blur", handleInputBlur);
				input.addEventListener("input", handleInputChange);

				// Check if the input field has a value on page load
				if (input.value !== "") {
					label.classList.add("active");
				}
			}
		}

		// Function to handle input focus event
		function handleInputFocus(event) {
			var input = event.target;
			var container = input.closest(".material-input");
			var label = container.querySelector("label");

			label.classList.add("active");
		}

		// Function to handle input blur event
		function handleInputBlur(event) {
			var input = event.target;
			var container = input.closest(".material-input");
			var label = container.querySelector("label");

			if (input.value === "") {
				label.classList.remove("active");
			}
		}

		// Function to handle input change event
		function handleInputChange(event) {
			var input = event.target;
			var container = input.closest(".material-input");
			var label = container.querySelector("label");

			if (input.value !== "") {
				label.classList.add("active");
			} else {
				label.classList.remove("active");
			}
		}
	}
);
